import { ImageType } from '@thesavingsgroup/enums/ImageType';
import { find } from 'lodash';

import { DashboardVehicle } from '../types/DashboardVehicle';

export const getVehicleDefaultImage = (
  vehicle: DashboardVehicle,
): string | undefined =>
  find(vehicle.images, (img) => img.type === ImageType.DEFAULT)?.url;
